import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./PlacaLandingPage.module.css";

const PlacaLandingPage = () => {
  const [hovered, setHovered] = useState(null); // Estado para detectar qué botón está activo al pasar el mouse

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Seleccione una opción</h1>

      <div className={styles.buttonContainer}>
        <Link to="/placas/terrenos">
          <button
            className={styles.buttonTerreno}
          >
            Terrenos
          </button>
        </Link>

        <Link to="/placas/inmueble">
          <button
            className={styles.buttonInmueble}
          >
            Inmuebles
          </button>
        </Link>

        <Link to="/placas/luxury">
          <button
            className={styles.buttonLuxury}
          >
            Lujosas
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PlacaLandingPage;
